import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Menu } from "primereact/menu";
import React, { useEffect, useRef, useMemo } from "react";
import { useRBAC } from "../../hooks/RBACContext";
import { WRITE_ACCESS_CTA } from "../../utils/Constants";
import "./DisplayTable.css";

const DisplayTable = ({
  data,
  parmKey,
  menuOptions,
  tableHeaders,
  setRowData,
  selectedPriceSchedules,
  setSelectedPriceSchedules,
  hideMenu = false,
  selectMode = false,
  multiSelect = false,
}) => {
  const menuLeft = useRef(null);

  const handleGearClick = (event, rowData) => {
    event.stopPropagation(); // Prevent event propagation
    setRowData(rowData);
    menuLeft.current.toggle(event);
  };
  const { writeAccess } = useRBAC();
  const filterMenuOptions = menuOptions.filter((menuOption) => {
    if (
      !writeAccess &&
      WRITE_ACCESS_CTA.some((option) =>
        menuOption.label.toUpperCase().includes(option)
      )
    ) {
      return false;
    }
    return true;
  });

  const onSelectionChange = (e) => {
   setSelectedPriceSchedules(e.value || []);
  };



  const gearIconTemplate = (rowData) => {
    return (
      <Button
        className="gear-button"
        rounded
        aria-label="settings"
        onClick={(event) => handleGearClick(event, rowData)}
      >
        <span className="material-icons">settings</span>
      </Button>
    );
  };

   const checkboxColumn = useMemo(() => {
		const checkboxColumnDef = {
			input: {
				tabIndex: 0,
				onKeyDown: (e) => {
					if (e.key === "Enter") {
						e.preventDefault();
						e.target.click();
					}
				},
			},
		};

		return (
			 (multiSelect || !selectMode) && (
				<Column
					selectionMode="multiple"
					headerStyle={{ width: "2em" }}
					pt={{
						headerCheckbox: checkboxColumnDef,
						rowCheckbox: checkboxColumnDef,
					}}
				/>
			)
		);
	}, [selectMode]);

  useEffect(() => {
    setSelectedPriceSchedules([]); // Reset selections whenever data changes
  }, [data, setSelectedPriceSchedules]);

  return (
    <div className="table-container">
      <DataTable
        value={data}
        paginator={false}
        dataKey={parmKey}
        selectionMode={null}
        selection={selectedPriceSchedules}
        onSelectionChange={onSelectionChange}
        emptyMessage="No data found"
        showGridlines
        stripedRows
      >
        {checkboxColumn}
        {!hideMenu && (
          <Column body={gearIconTemplate} headerStyle={{ width: "2em" }} />
        )}
        {tableHeaders.map(({ field, header, body }) => (
          <Column key={field} field={field} header={header} body={body} className="table-cell"/>
        ))}
      </DataTable>
      <Menu
        className="gear-option"
        model={filterMenuOptions}
        popup
        ref={menuLeft}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
          }
        }}
      />
    </div>
  );
};

export default DisplayTable;